'use strict';

const BaseStore = require('fluxible/addons/BaseStore');
const find = require('lodash.find');

class PinterestStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);

        this._user = {};
        this._boards = [];
        this._connectedBoard = null;

        this._connectAccountsModal = {
            isOpen: false
        };

        this._connectBoardModal = {
            isOpen: false,
            error: false
        };
    }

    _showConnectAccountsModal() {
        this._connectAccountsModal.isOpen = true;
        this.emitChange();
    }

    _hideConnectAccountsModal() {
        this._connectAccountsModal.isOpen = false;
        this.emitChange();
    }

    _showConnectBoardModal() {
        this._connectBoardModal.isOpen = true;
        this.emitChange();
    }

    _hideConnectBoardModal() {
        this._connectBoardModal.isOpen = false;
        this._connectBoardModal.error = false;
        this.emitChange();
    }

    _onConnectBoardModalError() {
        this._connectBoardModal.error = true;
        this.emitChange();
    }

    _onUserLoad(user) {
        this._user = user;
        this.emitChange();
    }

    _onBoardsLoad(boards) {
        this._boards = boards;
        this.emitChange();
    }

    _obBoardConnect(board) {
        this._connectedBoard = board;
        this._connectBoardModal.error = false;
        this.emitChange();
    }

    _onBoardCreated(board) {
        this._boards.push(board);
        this.emitChange();
    }

    _onDisconnect() {
        this._user = {};
        this._boards = [];
        this._connectedBoard = null;
        this.emitChange();
    }

    getConnectAccountsModal() {
        return this._connectAccountsModal;
    }

    getConnectBoardModal() {
        return this._connectBoardModal;
    }

    getUser() {
        return this._user;
    }

    getBoards() {
        return this._boards;
    }

    getBoard(id) {
        return find(this._boards, board => {
            return board.id === id;
        });
    }

    getBoardByName(name) {
        return find(this._boards, board => {
            return board.name === name;
        });
    }

    getConnectedBoard() {
        return this._connectedBoard;
    }

}

PinterestStore.storeName = 'PinterestStore';

PinterestStore.handlers = {
    'pinterest:connectAccountsModal:show': '_showConnectAccountsModal',
    'pinterest:connectAccountsModal:hide': '_hideConnectAccountsModal',
    'pinterest:connectBoardModal:show': '_showConnectBoardModal',
    'pinterest:connectBoardModal:hide': '_hideConnectBoardModal',
    'pinterest:connectBoardModal:error': '_onConnectBoardModalError',
    'pinterest:user:loaded': '_onUserLoad',
    'pinterest:boards:loaded': '_onBoardsLoad',
    'pinterest:boards:created': '_onBoardCreated',
    'pinterest:boards:error': '_onBoardCreated',
    'pinterest:board:connected': '_obBoardConnect',
    'pinterest:disconnected': '_onDisconnect'
};

module.exports = PinterestStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/PinterestStore.es.js